import { MessageBox } from 'mint-ui'

// 使用 TencentCaptcha
export const BehaviorCaptcha = {
  create({ onpass }) {
    const { TencentCaptcha } = window
    const appId = '2080528308'
    const options = {
      // sdkOpts: { 'width': 140, 'height': 140 }
    }
    this.aptcha = new TencentCaptcha(appId, (res) => {
      // 验证结果，0：验证成功。2：用户主动关闭验证码。
      console.log('TencentCaptcha>show: ', res)
      if (res.ret === 0) {
        onpass(res)
        // iCaptcha.destroy()
      }
    }, options)
  },
  show() {
    if (this.error) {
      MessageBox.alert('验证码验证模块设置失败，请刷新尝试').then(() => {
        location.reload()
      })
    } else {
      this.aptcha.show()
    }
  },
  destroy() {
    setTimeout(() => this.aptcha.destroy(), 500);
  }
}
